import React from 'react';
import '../less/aexpress.less';
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import AdditionalProduct from '../../../../../auxiliary-components/shared/AdditionalProductBlock';
import Advantages from '../../../../../auxiliary-components/shared/AdvantagesBlock';
import FilesForDownloadNew from "../../../../../auxiliary-components/shared/FilesForDownloadNew";
import { aExpressTariffsLink } from '../../../../../services/urls/urls';
import CalculatorNew from '../../../../../auxiliary-components/CalculatorNew';
import Tabs from '../../../../../auxiliary-components/shared/Tabs';
import Tariffs from '../../../../../auxiliary-components/shared/TariffsBlock';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import advantages_img_4 from '../img/advantages_img_4.png';
import advantages_img_5 from '../img/advantages_img_5.png';
import { Preloader } from 'MWComponents';
import additionalCards from '../enums/additional_cards_data.json';
import tariffs_data_standard from '../enums/tariffs_data_standard.json';
import tariffs_data_collateral_01 from '../enums/tariffs_data_collateral_01.json';
import tariffs_data_collateral_02 from '../enums/tariffs_data_collateral_02.json';
import hero_data from '../enums/hero_data.json';
import { getUrl } from "utils/corploansUrl";
import advantagesItemsData from '../enums/advantages_items.json';
import award_img from '../img/award_img.svg';
import { businessAllCreditProductAwardLink } from '../../../../../services/urls/urls';

export default function template() {
    const page = 'aexpress-new';
    const model = this.getModel();

    const openCorploansLink = () => window.open(getUrl());
    const tabs = [{tab: 'tariffs-standard', title: 'BUSINESS_AEXPRESS_NEW_TABS_TITLE_01'},
          {tab: 'tariffs-collateral', title: 'BUSINESS_AEXPRESS_NEW_TABS_TITLE_02'}];

    const awardBannerData = {
      link: businessAllCreditProductAwardLink,
      img: award_img,
      title: 'BUSINESS_AEXPRESS_BANNER_AWARDS_TITLE',
      text: 'BUSINESS_AEXPRESS_BANNER_AWARDS_TEXT'
    }

    const imagesMap = {
      advantages_img_1,
      advantages_img_2,
      advantages_img_3,
      advantages_img_4,
      advantages_img_5
    };

    const handlersMap = {
      openCorploansLink: openCorploansLink,
    };

    const heroData = {
      ...hero_data,
      link: {
        ...hero_data.link,
        onClick: handlersMap[hero_data.link.onClick],
      },
    };

    const advantagesItems = advantagesItemsData.map(item => ({
      ...item,
      img: imagesMap[item.img]
    }));

    return (
        <div className="aexpress-new">
          <Hero
            data={heroData}
            img={hero_img}
            page={page}
            award={awardBannerData}
          />
          <div className="content">
            <Advantages
              items={advantagesItems}
              title={'BUSINESS_AEXPRESS_NEW_ADVANTAGES_TITLE'}
            />
            <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab} page={page} title={'BUSINESS_AEXPRESS_NEW_CARDS_TARIFFS_TITLE'}>
              <Tariffs
                items={tariffs_data_standard}
                btnLink={aExpressTariffsLink}
                btnText={'BUSINESS_AEXPRESS_NEW_CARDS_TARIFFS_STANDARD_BTN'}
                page={page}
              />
              <div>
                <Tariffs
                  items={tariffs_data_collateral_01}
                />
                <Tariffs
                  items={tariffs_data_collateral_02}
                  title={'BUSINESS_AEXPRESS_NEW_CARDS_TARIFFS_COLLATERAL_TITLE'}
                  btnLink={aExpressTariffsLink}
                  btnText={'BUSINESS_AEXPRESS_NEW_CARDS_TARIFFS_COLLATERAL_BTN'}
                  page={page}
                />
              </div>
            </Tabs>
            {model.creditSum ? (
              <CalculatorNew model={model} type={"aexpress"} onBtnClick={openCorploansLink} {...this.props} page={page} currentName={model.currentName}/>
            ) : <Preloader />}
            <AdditionalProduct
              items={additionalCards}
              title={'BUSINESS_AEXPRESS_NEW_ADDITIONAL_PRODUCT_TITLE'}
              page={page}
            />
            <FilesForDownloadNew
              widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
              loader={this.state.loader}
            />
          </div>
        </div>
    );
}
